import React, { useEffect } from 'react';
import './TransferNextSteps.scss';
import { TransferConstant } from '../../TransferConstant';
import {
  SSJBeaconButton,
  SSJBeaconModal,
} from '../../../Shared/Beacon/Registry';

import printIcon from '../../../../assets/images/print-icon.svg';
import retirementIcon from '../../../../assets/images/retirement-icon.svg';
import downloadIcon from '../../../../assets/images/download-icon.svg';
import continueIcon from '../../../../assets/images/continue-icon.svg';
import { useSelector } from 'react-redux';
import { getEndpoint, callPdfGeneration } from '../../../../utils/api';
import config from '../../../../config/config';
import { getPersonalInformationData } from '../../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';
import {
  pdfGeneration,
  getMinorData,
} from '../../../../utils/fundingMethod/fundingMethodUtils';

export const handleModalClick = (action) => {
  const modal = document.querySelector('#downloadInvesTryAgian');
  if (modal === null) {
    return;
  }
  switch (action) {
    case 'TryAgain':
      modal.show();
      break;
    case 'Cancel':
      modal.close();
      break;
    default:
      break;
  }
};
export function getGeneratePdfFormPayload(
  fundingTrackingPayload,
  fundingTrackingStore,
  userInformation
) {
  const transferType = fundingTrackingPayload?.onboardingTransferType;
  const isCDFlow = fundingTrackingPayload?.transferCertificateOfDeposit;
  const accountType =
    fundingTrackingStore?.userAccountFundingData?.agreementType.replace(
      /JOINT_TENANT/g,
      'JOINT'
    );
  const minorName =
    accountType === 'UGMA_UTMA'
      ? getMinorData(
          fundingTrackingStore?.userAccountFundingData?.agreementParties
        )
      : {};

  // general payload
  const payload = {
    trpAccountNumber: fundingTrackingStore?.AccountAgreementNumber,
    trpAccountID: fundingTrackingStore?.AccountAgreementID,
    sourceAccountNumber:
      fundingTrackingPayload?.externalFinancialInstitutionNumber,
    sourceAccountType: accountType,
    destinationAccountType: accountType,
    customer: {
      // taxID will be added on flight.
      taxID: '',
      firstName:
        accountType === 'UGMA_UTMA'
          ? minorName.firstName
          : userInformation?.firstName,
      middleName:
        accountType === 'UGMA_UTMA'
          ? minorName.middleName
          : userInformation?.middleName,
      lastName:
        accountType === 'UGMA_UTMA'
          ? minorName.lastName
          : userInformation?.lastName,
      //phoneNumber will be added on flight.
      phoneNumber: '',
      jointOwners:
        accountType === 'UGMA_UTMA'
          ? [
              {
                jointOwnerFirstName: userInformation?.firstName,
                jointOwnerLastName: userInformation?.lastName,
                jointOwnerTaxID: ' ',
              },
            ]
          : [],
    },
  };

  if (isCDFlow) {
    return {
      ...payload,
      jsonSchemaType: 'BrokerageTransferFormWithCoDRequest',
      brokerageTransferExtendCD:
        fundingTrackingPayload?.certificateOfDepositTransferType,
      allCost: fundingTrackingPayload?.cashDollarValue === 'All Cash',
      dollarAmount:
        fundingTrackingPayload?.cashDollarValue === 'All Cash'
          ? 0
          : Number(fundingTrackingPayload?.cashDollarValue),
      percentage:
        fundingTrackingPayload?.cashDollarValue === 'All Cash' ? '100' : '',
      brokerageTransferLiquidationTimeFrame:
        fundingTrackingPayload?.certificateOfDepositLiquidationTimeFrame ===
        'UPON_MATURITY'
          ? 'MATURITY'
          : fundingTrackingPayload?.certificateOfDepositLiquidationTimeFrame,
      maturityDate: fundingTrackingPayload?.certificateOfDepositMaturityDate,
      custodianInformation: {
        custodianID: fundingTrackingPayload?.csdId,
        custodianName: fundingTrackingPayload?.externalFinancialInstituteName,
      },
    };
  } else if (transferType === 'FULL') {
    return {
      ...payload,
      jsonSchemaType: 'BrokerageTransferFormWithAssetRequest',
      custodianInformation: {
        custodianID: fundingTrackingPayload?.csdId,
        custodianName: fundingTrackingPayload?.externalFinancialInstituteName,
      },
      transferExtent: 'FULL',
    };
  } else if (transferType === 'PARTIAL') {
    const assetList = [];
    const assetListFilter =
      fundingTrackingPayload.onboardingTransferSecurityDetail?.filter(
        (item) =>
          item?.securityTicker !== '' &&
          item?.securityTicker &&
          item?.securityTicker !== 'null' &&
          (Number(item?.securityQuantity) >= 0 ||
            item?.securityQuantity === 'All Shares')
      );
    if (assetListFilter?.length > 0) {
      assetListFilter.map((item) => {
        return assetList.push({
          '@Type': 'BrokerageSecurityTransferAsset',
          securityName: item?.securityTicker,
          ...(!(item?.securityQuantity === 'All Shares') && {
            amount: Number(item?.securityQuantity),
          }),
          allShares: item?.securityQuantity === 'All Shares' ? true : false,
        });
      });
    }
    if (fundingTrackingPayload?.cashDollarValue !== 0) {
      assetList.push({
        '@Type': 'BrokerageCashTransferAsset',
        dollarAmount: fundingTrackingPayload?.cashDollarValue,
      });
    }
    return {
      ...payload,
      jsonSchemaType: 'BrokerageTransferFormWithAssetRequest',
      custodianInformation: {
        custodianID: fundingTrackingPayload?.csdId,
        custodianName: fundingTrackingPayload?.externalFinancialInstituteName,
      },
      transferExtent: 'PARTIAL',
      assets: assetList,
    };
  }
}
const TransferNextSteps = () => {
  useEffect(() => {
    dispatchPageLoad('Sign and Mail Form');
  }, []);
  const userInformation = useSelector(getPersonalInformationData);
  const fundingTrackingPayload = useSelector(
    (state) =>
      state.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreTransfer
  );
  const fundingTrackingStore = useSelector(
    (state) => state?.fundingTrackingData?.store
  );
  const downloadTransferForm = async () => {
    // using uniq pdf api
    try {
      const pdfResponse = await callPdfGeneration(
        getEndpoint('generatePdfForm'),
        { method: 'POST' },

        JSON.stringify(
          getGeneratePdfFormPayload(
            fundingTrackingPayload,
            fundingTrackingStore,
            userInformation
          )
        )
      );
      pdfGeneration(pdfResponse);
    } catch (err) {
      console.log('Error:', err);
      handleModalClick('TryAgain');
    }
  };

  return (
    <div className="nextStep-wrapper">
      <div className="nextStep-wrapper_header">
        <h2 className="nextStep-wrapper_header_text">
          {TransferConstant.nextStepsPage.headerTitle}
        </h2>
        <div className="nextStep-wrapper_header_print">
          <SSJBeaconButton
            data-testid="beacon-button"
            id="printButton"
            label="Print"
            variant="tertiary"
            icon-align="left"
            onClick={() => {
              window.print();
            }}
          >
            <img
              slot="icon"
              icon-align="left"
              alt="Print Button"
              fill="none"
              className="nextStep-wrapper_header_print_icon"
              height="18"
              width="18"
              src={printIcon}
            />
          </SSJBeaconButton>
        </div>
      </div>
      <p className="nextStep-wrapper_desc">
        {TransferConstant.nextStepsPage.pageDesc}
      </p>
      <div className="nextStep-wrapper_pointers">
        <div className="nextStep-wrapper_pointers_step">
          <div className="nextStep-wrapper_pointers_step_box">
            <p className="nextStep-wrapper_pointers_step_text">
              {TransferConstant.nextStepsPage.stepTitle1}
            </p>
            <p className="nextStep-wrapper_pointers_step_accType">
              <span>{`${fundingTrackingPayload?.externalFinancialInstituteName} ${fundingTrackingStore?.normalizedAccountType}`}</span>
            </p>
            <p className="nextStep-wrapper_pointers_step_accNo blocked_data">
              {fundingTrackingStore?.AccountAgreementNumber}
              <span className="dot" />
              {`${fundingTrackingStore?.userAccountFundingData?.agreementParties[0]?.fullName}`}
            </p>
            <SSJBeaconButton
              data-testid="transfer-button"
              id="transfer-form-btn"
              className="submit-btn"
              label="Download Transfer Form"
              icon-align="left"
              variant="primary"
              scale="jumbo"
              onClick={downloadTransferForm}
            >
              <img
                slot="icon"
                icon-align="left"
                alt="Download Slip Button"
                className="continue-arrow-icon"
                fill="none"
                height="16"
                width="16"
                src={downloadIcon}
              />
            </SSJBeaconButton>
          </div>
        </div>
        <div className="nextStep-wrapper_pointers_step">
          <div className="nextStep-wrapper_pointers_step_box">
            <p className="nextStep-wrapper_pointers_step_text">
              {`Print your latest ${fundingTrackingStore?.normalizedAccountType} statement from ${fundingTrackingPayload?.externalFinancialInstituteName}`}
            </p>
          </div>
        </div>
        <div className="nextStep-wrapper_pointers_step">
          <div className="nextStep-wrapper_pointers_step_box">
            <p className="nextStep-wrapper_pointers_step_text">
              {TransferConstant.nextStepsPage.stepTitle3}
            </p>
            <p className="nextStep-wrapper_pointers_step_addressTitle">
              Mail To:
            </p>
            <p className="nextStep-wrapper_pointers_step_address">
              T. Rowe Price <br />
              P.O. Box 17300 <br />
              Baltimore, MD 21297-1300
            </p>
            <p className="nextStep-wrapper_pointers_step_addressTitle">
              Express delivery only:
            </p>
            <p className="nextStep-wrapper_pointers_step_address">
              T. Rowe Price Mail Code 17150 <br />
              4515 Painters Mill Road <br />
              Owing Mills, MD 21117-4903
            </p>
          </div>
        </div>
        <div className="nextStep-wrapper_note">
          <div className="retirement-icon">
            <img src={retirementIcon} alt="retirement-icon" />
          </div>
          <div className="nextStep-wrapper_note_text">
            <div className="nextStep-wrapper_note_text_title">
              {TransferConstant.nextStepsPage.noteTitle}
            </div>
            <p className="nextStep-wrapper_note_text_desc">
              {TransferConstant.nextStepsPage.noteText}
            </p>
          </div>
        </div>
      </div>
      <SSJBeaconButton
        data-testid="handle-continue-button"
        id="nextStepCtnBtn"
        label="Go to My Account Dashboard   >"
        variant="secondary"
        scale="jumbo"
        onClick={() =>
          (window.location.href = `${config.url}/usis/my-accounts/dashboard`)
        }
      >
        <img
          slot="icon"
          alt="Continue Button"
          className="continue-arrow-icon"
          src={continueIcon}
        />
      </SSJBeaconButton>

      <SSJBeaconModal
        id="downloadInvesTryAgian"
        scale="normal"
        elevation="3"
        closeonclickout=""
      >
        <p className="beacon-modal__title">Something went wrong</p>
        <p className="beacon-modal__description">
          {`There was an issue generating your transfer form but your information is not lost. Please try again. If the problem persists, you can call a service specialist at (855) 793-6611.`}
        </p>
        <div className="download-invest-try-again">
          <div className="download-invest-try-again_container">
            <SSJBeaconButton
              data-testid="cancel-button"
              id="saveButton"
              type="button"
              variant="tertiary"
              onClick={() => handleModalClick('Cancel')}
              label="Cancel"
            />
            <SSJBeaconButton
              data-testid="download-form-button"
              id="exitButton"
              type="button"
              variant="negative"
              onClick={downloadTransferForm}
              label="Try again"
            />
          </div>
        </div>
      </SSJBeaconModal>
    </div>
  );
};

export default TransferNextSteps;
